import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function DirectBookingBanner({ onRegisterClick, onBookingClick, onAmenitiesClick }) {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-emerald-800 rounded-3xl p-6 md:p-8 text-white shadow-xl shadow-emerald-900/20 mb-8 overflow-hidden relative"
    >
      <div className="absolute top-0 right-0 -mt-4 -mr-4 opacity-10">
        <SafeIcon name="Zap" className="w-32 h-32" />
      </div>
      
      <div className="relative z-10 text-center md:text-left">
        <h2 className="text-2xl md:text-3xl font-bold mb-3 leading-tight">
          ¿Ya reservaste en Airbnb? <br className="hidden md:block" />
          Reserva directo y ahorra
        </h2>
        <p className="text-emerald-100 mb-8 max-w-lg text-lg opacity-90 mx-auto md:mx-0">
          Sin comisiones de plataforma. Mismo apartamento, mejor precio para ti y para nosotros.
        </p>
        
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center md:justify-start">
          <button
            onClick={onRegisterClick}
            className="bg-emerald-900/50 hover:bg-emerald-900/80 text-white font-bold py-4 px-6 rounded-2xl transition-all border border-emerald-700/50 flex items-center justify-center gap-2 group flex-1 min-w-[200px]"
          >
            <SafeIcon name="UserCheck" className="group-hover:translate-x-1 transition-transform" />
            Check-in / Registro
          </button>
          
          <button
            onClick={onBookingClick}
            className="bg-white hover:bg-emerald-50 text-emerald-900 font-bold py-4 px-6 rounded-2xl transition-all shadow-lg flex items-center justify-center gap-2 group flex-1 min-w-[200px]"
          >
            Ver disponibilidad y reservar
            <SafeIcon name="ArrowRight" className="group-hover:translate-x-1 transition-transform" />
          </button>

          <button
            onClick={onAmenitiesClick}
            className="w-full bg-emerald-700/30 hover:bg-emerald-700/50 text-white font-bold py-4 px-6 rounded-2xl transition-all border border-emerald-500/30 flex items-center justify-center gap-2 group"
          >
            <SafeIcon name="Zap" className="group-hover:scale-110 transition-transform" />
            Reservar Amenidades
          </button>
        </div>
      </div>
    </motion.div>
  );
}